import localStorageHelper from '@/assets/modules/localStorageHelper'

export default {
  methods: {
    closeConnector (e) {
      e = Object.assign({}, e, { auth: true })
      this.$emit('closeConnector', e)
    },

    connectChannel () {
      if (!!this.beforeConnect) { (this.beforeConnect)() }
      localStorageHelper.setData('authConnection', 'attemptedConnection', true)

      let dest = {
        name: this.$route.name || '',
        path: this.$route.path,
        params: this.$route.params
      }
      localStorageHelper.setData('authConnection', 'destination', dest)

      window.location = this.getAuthLink
      this.$emit('closeConnector', {successfull: true})
    }
  },

  computed: {
    getAuthLink () {
      let querySeperator = '?'
      if (this.getAuthExtension.indexOf(querySeperator) > -1) {
        querySeperator = '&'
      }

      return `${process.env.AUTH_BASE}/${this.getAuthExtension}${querySeperator}jwt=${localStorageHelper.getData('user', 'token')}`
    }
  },

  props: {
    beforeConnect: {
      type: Function,
      required: false,
      default: undefined
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/standard/connections/authConnector.js